export let SessionStatus = {
  ACTIVE: {text: 'Ativa', value: 'Ativa'},
  STARTED: {text: 'Iniciar Sessão', value: 'Iniciada'},
  CLOSED: {text: 'Encerrar Sessão', value: 'Encerrada'},
  REACTIVE: {text: 'Reativar Sessão', value: 'Ativa'},
}
